export default __webpack_public_path__ + "static/media/MichaelStolls.40760ada.jpg";